import React, { useEffect, useState } from 'react';
import SEO from '../components/Seo';
import { navigate } from 'gatsby';
import qs from 'query-string';

import Wrapper from '../components/styled/Wrapper';

import Footer from '../components/layout/Footer';

import Sorting from '../components/projects/Sorting';
import AccordionGroup from '../components/projects/AccordionGroup';
import Bottom from '../components/projects/Bottom';

const Projects = ({
  data,
  contextData,
  contextSet,
  langTo,
  cats,
  location,
}) => {
  const [currCat, setCurrCat] = useState('');
  const [currCatLabel, setCurrCatLabel] = useState('Kategoria');
  const [currSort, setCurrSort] = useState('');
  const [currSortLabel, setCurrSortLabel] = useState('Sortuj');
  const [filteredData, setFilteredData] = useState(data.projects);
  const [currQuery, setCurrQuery] = useState('');

  const sortAZ = (a, b) => {
    var nameA = a.title.toUpperCase(); // ignore upper and lowercase
    var nameB = b.title.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  };

  const sortZA = (a, b) => {
    var nameA = a.title.toUpperCase(); // ignore upper and lowercase
    var nameB = b.title.toUpperCase(); // ignore upper and lowercase
    if (nameA > nameB) {
      return -1;
    }
    if (nameA < nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  };

  const sort = (els, how) => {
    if (how === 'a-z') {
      const sorted = [...els].sort((a, b) => sortAZ(a, b));
      setFilteredData([...sorted]);
    } else if (how === 'z-a') {
      const sorted = [...els].sort((a, b) => sortZA(a, b));
      setFilteredData([...sorted]);
    }
  };

  useEffect(() => {
    let filtered = [];

    if (currCat !== '' && currCat !== 'all') {
      filtered = data.projects.filter(item => {
        return item.projectCategories.some(el => el.slug === currCat);
      });

      navigate(`/works?${qs.stringify({ cat: currCat })}`);

      if (currSort !== '') {
        sort(filtered, currSort);
      } else {
        setFilteredData(filtered);
      }
    } else {

      if (currCat !== '') {
        navigate(`/works?${qs.stringify({ cat: currCat })}`);
      }
      
      if (currSort !== '') {
        sort(data.projects, currSort);
      } else {
        setFilteredData(data.projects);
      }
    }
  }, [currCat, currSort]);

  useEffect(() => {
    const isEn = !langTo.startsWith('/en');
    contextSet({ langTo: langTo, isEn: isEn });
  }, []);

  return (
    <React.Fragment>
      <SEO
        title={data.seoTitle}
        description={data.seoDescription}
        image={data.seoImage}
      />
      <Sorting
        cats={cats}
        currCat={currCat}
        currCatLabel={currCatLabel}
        currSortLabel={currSortLabel}
        currSort={currSort}
        setCurrCat={setCurrCat}
        setCurrCatLabel={setCurrCatLabel}
        setCurrSort={setCurrSort}
        setCurrSortLabel={setCurrSortLabel}
        isEn={contextData.isEn}
        currQuery={currQuery}
        setCurrQuery={setCurrQuery}
        location={location}
        contextSet={contextSet}
        contextData={contextData}
      />
      <Wrapper>
        <AccordionGroup
          items={filteredData}
          isEn={contextData.isEn}
          small={contextData.smallProjects}
        />
        <Bottom>
          <Footer isEn={contextData.isEn} />
        </Bottom>
      </Wrapper>
    </React.Fragment>
  );
};

export default Projects;
